/**
 * 将要上传的form表单数据预处理
 */

import { Region } from '@lemon8/web-app-shared/i18n';
import { ReportType } from 'shared/types/report';

function formatFormData(data: any, countryRegion: Region, reportType: ReportType, isInApp: boolean) {
  const fileTypeMap = {
    proofFiles: 2,
    materialFiles: 1,
    certificateFiles: 3,
  };
  const {
    ownerName,
    legalOwner,
    address,
    phone,
    email,
    relationship,
    proofFiles,
    contentURL,
    contentType,
    typeDescription,
    materialFiles,
    signature,
    certificateFiles,
    cfGoods,
    goodsAndClass,
    infringementDescription,
    registrationJurisdiction,
    registrationNumber,
    recordUrl,
  } = data;

  function formatFiles(files: any[], fileType: number) {
    return files.map((item: any) => {
      return {
        fileName: item.fileName,
        fileUrl: item.fileUrl,
        tosURI: item.tosURI,
        type: fileType,
      };
    });
  }

  const res: any = {
    language: 'en',
    pid: '3593',
    reportType,
    isInApp,
    idcRegion: __BUILD_REGION__,
    reporterDto: {
      address,
      email,
      ownerName,
      phone,
      relationship: Number(relationship),
      reporterRegion: countryRegion,
      signature,
      legalOwner,
    },
  };

  if (reportType === ReportType.COPYRIGHT) {
    res.copyrightDto = {
      contentType: Number(contentType),
      contentURL,
      proofFiles: formatFiles(proofFiles, fileTypeMap.proofFiles),
      typeDescription,
      materialFiles: formatFiles(materialFiles, fileTypeMap.materialFiles),
    };
  } else if (reportType === ReportType.TRADEMARK) {
    res.trademarkDto = {
      certificateFiles: formatFiles(certificateFiles, fileTypeMap.certificateFiles),
      contentURL,
      goodsAndClass,
      infringementDescription,
      materialFiles: formatFiles(materialFiles, fileTypeMap.materialFiles),
      proofFiles: formatFiles(proofFiles, fileTypeMap.proofFiles),
      registrationJurisdiction,
      registrationNumber,
      recordUrl,
    };

    res.extra = {
      cfGoods: Number(cfGoods),
    };
  }
  return res;
}

export default formatFormData;
